import React from 'react'
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  List, 
  ListItem, 
  ListItemText 
} from '@mui/material'
import { Edit, Delete } from '@mui/icons-material'
import { ConfirmDialogProps } from '../types'
import { Typography } from '../../../interfaces/typography'

export function ConfirmDialog({ 
  open, 
  changes, 
  onClose, 
  onConfirm 
}: ConfirmDialogProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px'
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: '1.25rem', 
        fontWeight: 600,
        color: '#DC2626',
        paddingBottom: 1
      }}>
        <Typography variant="h3" color="#DC2626" fontWeight={600}>
          Confirm Potentially Breaking Changes
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="mediumParagraph" color="#6B7280" className="mb-4">
          The following changes may affect existing scores and reports:
        </Typography>
        
        <List dense>
          {changes.map((change, index) => (
            <ListItem key={index} sx={{ 
              backgroundColor: '#FEF2F2', 
              borderRadius: '8px', 
              mb: 1,
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}>
              <ListItemText 
                primary={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Edit sx={{ fontSize: 16, color: '#DC2626' }} />
                    <Typography variant="mediumParagraph" color="#1F2937" fontWeight={500}>
                      {change.label}
                    </Typography>
                  </div>
                }
              />
              <List dense sx={{ width: '100%', pl: 3 }}>
                {change.changes.map((changeDetail: string, idx: number) => (
                  <ListItem key={idx} sx={{ py: 0 }}>
                    <ListItemText 
                      primary={
                        <Typography variant="smallParagraph" color="#6B7280">
                          • {changeDetail}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </ListItem>
          ))}
        </List>
        
        <Typography variant="mediumParagraph" color="#6B7280" className="mt-4">
          Are you sure you want to continue?
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ gap: 1, p: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ 
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          <Typography variant="mediumParagraph" color="inherit" fontWeight={500}>
            Cancel
          </Typography>
        </Button>
        <Button 
          onClick={() => onConfirm()}
          variant="contained"
          color="error"
          sx={{ 
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 500,
            backgroundColor: '#DC2626',
            '&:hover': {
              backgroundColor: '#B91C1C'
            }
          }}
        >
          <Typography variant="mediumParagraph" color="inherit" fontWeight={500}>
            Continue
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
} 